import { useEffect } from 'react';

import { TilePlaceholder } from 'pages/dashboard/components';
import { DashboardApi, Message } from 'apis/DashboardApi';
import { Button, Card, Collapse } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

export const MessagesTile = () => {

    const { formatMessage } = useIntl();

    const { highestRole, selectedPartner, userId } = useApp();

    const [state, setState] = useSuperState({
        collapsed: false,
        data: [] as Message[],
        loading: true,
        removing: null as number
    });
    const { collapsed, data, loading } = state;

    const fetchMessages = async () => {

        try {

            const messages = await DashboardApi.GetMessages(userId, highestRole.id, selectedPartner.id);
            setState({
                data: messages,
                loading: false
            });

        } catch {

            setState({ loading: false });

        }

    };

    const handleRemove = async (messageId: number) => {

        try {

            setState({ removing: messageId });

            await DashboardApi.RemoveMessage(userId, messageId);
            await fetchMessages();

            setState({ removing: null });

        } catch {

            // Silently fail — message will remain visible
        }

    };

    const formatDate = (dateStr: string) => {

        const date = new Date(dateStr);
        return date.toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' });

    };

    const isBeingRemoved = (id: number) => state.removing === id;

    useEffect(() => {

        fetchMessages();

    }, []);

    const items = data ?? [];

    return (
        <>
            {loading ?
                (
                    <TilePlaceholder/>
                )
                :
                (
                    <>

                        <Card className={'overflow-hidden'}>
                            <Card.Header
                                className="d-flex justify-content-between align-items-center text-uppercase"
                                onClick={() => setState({ collapsed: !collapsed })}
                                role="button"
                            >
                                <strong>
                                    <i className="fa-solid fa-envelope me-2" />
                                    {<FormattedMessage defaultMessage="Messages" id="messages.068d7b13" />}
                                    {!!items?.length && (
                                        <small className={'text-muted ms-1'}>
                                            (
                                            {items.length}
                                            )
                                        </small>
                                    )}
                                </strong>
                                <i className={`fa-solid ${collapsed ? 'fa-chevron-down' : 'fa-chevron-up'}`} />
                            </Card.Header>

                            <Collapse in={!collapsed}>
                                <div className={'messages'}>
                                    <Card.Body className="p-0">
                                        {items?.length ?
                                            (
                                                <>
                                                    {items.map(message => (
                                                        <div className={`message position-relative p-3 border-bottom${isBeingRemoved(message.Id) ? ' disabled' : ''}`} key={message.Id}>
                                                            <div className="d-flex justify-content-between align-items-start">
                                                                <span>
                                                                    {<FormattedMessage defaultMessage="From" id="from.38ce4c90" />}
                                                                    :
                                                                    {' '}
                                                                    <strong>
                                                                        {message.PartnerName}
                                                                    </strong>
                                                                </span>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <span className="text-muted small">
                                                                        {formatDate(message.StartDate)}
                                                                    </span>
                                                                    <Button
                                                                        className={'text-danger text-decoration-none p-0'}
                                                                        disabled={loading || isBeingRemoved(message.Id)}
                                                                        onClick={() => handleRemove(message.Id)}
                                                                        size={'sm'}
                                                                        title={formatMessage({ id: 'remove_message.a82e9dd0', defaultMessage: 'Remove message' })}
                                                                        variant={'link'}
                                                                    >
                                                                        <i className={'fa-regular fa-trash-can-xmark'} />

                                                                    </Button>
                                                                </div>
                                                            </div>
                                                            <hr className="my-2" />
                                                            <div dangerouslySetInnerHTML={{ __html: message.Text }} />
                                                        </div>
                                                    ))}
                                                </>
                                            )
                                            :
                                            (
                                                <div className={'p-5 d-flex flex-column align-items-center justify-content-center'}>
                                                    <span className={'text-muted'}>

                                                        <FormattedMessage defaultMessage="No messages available" id="no_messages_available.3dcd8130" />
                                                    </span>
                                                </div>
                                            )
                                        }

                                    </Card.Body>
                                </div>
                            </Collapse>
                        </Card>

                    </>
                )
            }

        </>
    );

};
